import React from 'react'

import {
  readyForReceiving,
  preprocessingComplete,
  receivingContext,
  canOverReceive,
  getReceiptQuantities,
  ReceivingFlowController,
} from '../flow'
import { RfShell } from '../components/RfShell'
import { RfStatusBanner } from '../components/RfStatusBanner'
import { VariantSummary } from '../components/VariantSummary'
import { MenuButton, TaskHeader, VariantActionList } from '../styles'

interface VariantMenuScreenProps {
  controller: ReceivingFlowController
  embedded?: boolean
  onExit: () => void
}

export const VariantMenuScreen = ({ controller, embedded = false, onExit }: VariantMenuScreenProps) => {
  const { state, dispatch } = controller
  if (!state.activeVariant) return null

  return (
    <RfShell
      title="Receiving"
      phase="Select variant"
      embedded={embedded}
      contextSummary={receivingContext(state)}
      contextDetails={null}
      onBack={() => dispatch({ type: 'back' })}
      moreActions={[{ label: 'Exit receiving', onSelect: onExit, danger: true }]}
    >
      {state.status && state.status.tone !== 'success' ? (
        <RfStatusBanner tone={state.status.tone}>{state.status.message}</RfStatusBanner>
      ) : null}
      <TaskHeader>
        <h1>Variant receiving</h1>
      </TaskHeader>
      <VariantSummary
        variant={state.activeVariant}
        lineAddedToAsn={state.lineAddedToAsn}
        additional={getReceiptQuantities(state).additional}
      />
      <VariantActionList aria-label="Variant receiving actions">
        <MenuButton type="button" onClick={() => dispatch({ type: 'start-preprocess' })}>
          <strong>Preprocess variant</strong>
        </MenuButton>
        <MenuButton
          type="button"
          disabled={!preprocessingComplete(state)}
          onClick={() => dispatch({ type: 'open-label-processing' })}
        >
          <strong>Label processing</strong>
        </MenuButton>
        <MenuButton
          type="button"
          disabled={!canOverReceive(state)}
          onClick={() => dispatch({ type: 'open-over-receive' })}
        >
          <strong>Over receive</strong>
        </MenuButton>
        <MenuButton
          type="button"
          disabled={!readyForReceiving(state)}
          onClick={() => dispatch({ type: 'continue-to-receiving' })}
        >
          <strong>Receive</strong>
        </MenuButton>
        <MenuButton
          type="button"
          disabled={!state.labels.some((label) => label.printed)}
          onClick={() => dispatch({ type: 'open-reprint-labels' })}
        >
          <strong>Reprint labels</strong>
        </MenuButton>
        <MenuButton type="button" onClick={() => dispatch({ type: 'select-another-variant' })}>
          <strong>Select another variant</strong>
        </MenuButton>
        <MenuButton type="button" onClick={() => dispatch({ type: 'open-stage-asn' })}>
          <strong>Review receiving</strong>
        </MenuButton>
      </VariantActionList>
    </RfShell>
  )
}
